import React, { FC, useEffect, useRef, useState } from 'react';

import {
  Box,
  Button,
  Center,
  Input,
  LightMode,
  Stack,
  Text,
} from '@chakra-ui/react';
import { isString } from 'lodash';
import { customTheme } from 'theme';

import { Heading1, Heading3 } from 'components/DataDisplay';
import { textFieldStyles } from 'components/DataEntry';
import { LogoDark } from 'components/Navigation/NavBar/LogoDark';
import { rememberedOrganizations } from 'containers/App/keycloak/rememberedOrganizations';

interface IOrganizationLoginInput {
  handleSubmit(data);
}

export const OrganizationLoginInput: FC<IOrganizationLoginInput> = props => {
  const { handleSubmit } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  // Organizations this browser signed in to before; one click picks one.
  const [recent] = useState(rememberedOrganizations);

  useEffect(() => {
    if (!recent.length) inputRef.current?.focus();
  }, [recent.length]);

  return (
    <LightMode>
      <Box
        bg={customTheme.colors.gray['50']}
        px={[6, 8, 12]}
        py={'120px'}
        minH={window.innerHeight}
        id="login"
      >
        <Stack spacing={40}>
          <Box>
            <Stack spacing={0} mt={10}>
              <Center>
                <LogoDark w={48} />
              </Center>
              <Center color={'primary'}>
                <Heading1>Cloud Security for the Agentic Enterprise</Heading1>
              </Center>
            </Stack>
          </Box>
          <Center>
            <Stack maxW="md" w={'400px'} spacing={4}>
              {recent.length > 0 && (
                <Stack spacing={2} pb={4}>
                  <Heading3>Continue to</Heading3>
                  {recent.map(organization => (
                    <Button
                      key={organization}
                      variant="outline"
                      justifyContent="flex-start"
                      bg="white"
                      h="42px"
                      onClick={() => handleSubmit({ organization })}
                    >
                      {organization}
                    </Button>
                  ))}
                  <Text pt={2} fontSize="sm" color="gray.500">
                    Or sign in to another organization:
                  </Text>
                </Stack>
              )}
              <Heading3>Name of your Organization</Heading3>
              <Input
                {...textFieldStyles.input}
                ref={inputRef}
                borderRadius={6}
                h={'38px'}
                placeholder={'Type and press Enter'}
                onKeyDown={e => {
                  const value = (e.target as HTMLInputElement).value;
                  if (e.key === 'Enter') {
                    if (!isString(value)) {
                      return;
                    }

                    handleSubmit({ organization: value?.trim() });
                  }
                }}
              />
              {/*<Form*/}
              {/*  schema={{*/}
              {/*    organization: {*/}
              {/*      type: 'text',*/}
              {/*      placeholder: 'Organization',*/}
              {/*      isRequired: true,*/}
              {/*    },*/}
              {/*  }}*/}
              {/*  buttonOptions={{*/}
              {/*    submit: { name: 'Go to Login' },*/}
              {/*  }}*/}
              {/*  styles={{*/}
              {/*    form: {*/}
              {/*      formWidth: 'full',*/}
              {/*      container: { mt: 1 },*/}
              {/*      buttonGroup: { mt: 8, w: 'full' },*/}
              {/*      submitButton: {*/}
              {/*        color: 'white',*/}
              {/*        background: 'primary',*/}
              {/*        w: 'full',*/}
              {/*        size: 'lg',*/}
              {/*        _hover: {*/}
              {/*          color: 'white',*/}
              {/*          background: 'primary',*/}
              {/*          borderShadow: '10px red',*/}
              {/*        },*/}
              {/*      },*/}
              {/*      submitButtonGroup: {*/}
              {/*        w: 'full',*/}
              {/*      },*/}
              {/*    },*/}
              {/*    textField: {*/}
              {/*      input: { fontSize: 'md' },*/}
              {/*    },*/}
              {/*    objectField: {*/}
              {/*      ...inlineObjectFieldStyles,*/}
              {/*      propertyContainer: { w: 'full' },*/}
              {/*    },*/}
              {/*  }}*/}
              {/*  overwriteDefaultStyles*/}
              {/*  handleSubmit={handleSubmit}*/}
              {/*/>*/}
            </Stack>
          </Center>
        </Stack>
      </Box>
    </LightMode>
  );
};
